import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

export const DREAMING_TRIGGERS = ["pr_closed", "manual"] as const;
export type DreamingTrigger = (typeof DREAMING_TRIGGERS)[number];

/** A member's dreaming preferences for one org, every field resolved to its default by the backend. */
export type UserDreamingSettings = {
  dreaming_enabled: boolean;
  dreaming_trigger: DreamingTrigger;
};

export type UserDreamingSettingsUpdate = Partial<UserDreamingSettings>;

const hooks = createUserOrgSettingsHooks<UserDreamingSettings>({
  resource: "user-dreaming-settings",
  errorMessage: "Failed to update dreaming settings",
});

export const useUserDreamingSettings = hooks.useSettings;
export const useUpdateUserDreamingSettings = hooks.useUpdateSettings;
